import { GlobalStyles } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import ReactToPrint from 'react-to-print';
import {
  NotificationContainer,
  NotificationManager,
} from 'react-notifications';
import image from '../images/loader.gif';
import PrintComponent from './PrintComponent'; // Make sure the path is correct

const Results = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState();
  const [backdrop, setBackdrop] = useState(true);
  const [url, setUrl] = useState();
  const [inv, setInv] = useState(false);
  const [formData, setFormData] = useState({});
  const printRef = useRef();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/');
    window.location.reload();
  };

  const back = () => {
    navigate('/');
  };

  const onSubmit = (data) => {
    data.user = JSON.parse(window.localStorage.getItem('user')).user.id;
    data.count = Number(data.count) + 1;
    let endp = 'https://ibidaz.com/inventory/phpfiles/save.php';
    fetch(endp, {
      headers: { Authorization: `${window.localStorage.getItem('token')}` },
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((dat) => {
        setValue('count', data?.count);
        setInv(true);
        NotificationManager.success('Product saved successfully', 'Success');
      });
  };

  const calculateOurPrice = () => {
    const retailPrice = formData.wasPrice || formData.price;
    return Math.round(parseFloat(retailPrice) * 0.7);
  };

  useEffect(() => {
    setLoading(true);
    document.querySelector('body').style.overflow = 'hidden';
    fetch('https://ibidaz.com/inventory/phpfiles/search.php?id=' + id, {
      method: 'GET',
      headers: { Authorization: `${window.localStorage.getItem('token')}` },
    })
      .then((res) => res.json())
      .then((prodata) => {
        setLoading(false);
        document.querySelector('body').style.overflow = 'auto';
        if (prodata?.results) {
          setBackdrop(false);
          let data = prodata.results;
          setUrl(data?.main_image);
          setInv(prodata.status);
          setValue('link', data?.link);
          setValue('brand', data?.brand);
          setValue('title', data?.title);
          setValue('upc', data?.upc);
          setValue('gtin', data?.gtin);
          setValue('item_id', data?.item_id);
          setValue('store_sku', data?.store_sku);
          setValue('sec_store_sku', data?.sec_store_sku);
          setValue('model_number', data?.model_number);
          setValue('description', data?.description);
          setValue('feature_bullets', data?.feature_bullets);
          setValue('images', data?.images);
          setValue('main_image', data?.main_image);
          setValue('rating', data?.rating);
          setValue('descriptive_attributes', data?.descriptive_attributes);
          setValue('specifications', data?.specifications);
          setValue('categories', data?.categories);
          setValue('price', data?.price);
          setValue('was_price', data?.was_price);
          setValue('date', data?.date);
          setValue('count', data?.count);
          setValue('user', data?.user);
          setFormData({
            item_id: data?.item_id,
            brand: data?.brand,
            title: data?.title,
            price: data?.price,
            wasPrice: data?.was_price,
          });
        } else {
          NotificationManager.error('No product info found.', 'Error');
        }
      })
      .catch((err) => {
        setLoading(false);
        NotificationManager.error('No product info found.', 'Error');
        document.querySelector('body').style.overflow = 'auto';
      });
  }, []);

  const printStyle = {
    '@media print': {
      '@page': {
        size: 'portrait',
        // size: '2.3in 4in',
      },
      body: {
        marginTop: '85px',
      },
    },
  };

  return (
    <div className='container'>
      <GlobalStyles styles={printStyle} />
      {backdrop && (
        <div className='loading'>
          {loading ? (
            <img src={image} alt='' />
          ) : (
            <button className='logout_btn' onClickCapture={back}>
              NEW SEARCH
            </button>
          )}
        </div>
      )}
      <NotificationContainer />
      <div className='logout'>
        <h1>Product</h1>
        <button className='logout_btn' onClickCapture={logout}>
          LOGOUT
        </button>
      </div>
      <hr />
      <br />
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='control'>
          <label htmlFor=''>Title</label>
          <input
            type='text'
            style={{ border: `${errors.title ? '1px solid tomato' : ''}` }}
            {...register('title', { required: false })}
          />
        </div>
        <div className='middle'>
          <input type='hidden' {...register('images', { required: false })} />
          <input
            type='hidden'
            {...register('main_image', { required: false })}
          />
          <input type='hidden' {...register('gtin', { required: false })} />
          <input type='hidden' {...register('link', { required: false })} />
          <div className='img'>{url && <img src={url} alt='' />}</div>
          <div className='info'>
            <div className='control'>
              <label htmlFor=''>brand:</label>
              <input
                type='text'
                style={{ border: `${errors.brand ? '1px solid tomato' : ''}` }}
                {...register('brand', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>upc:</label>
              <input
                type='text'
                style={{ border: `${errors.upc ? '1px solid tomato' : ''}` }}
                {...register('upc', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>item_id:</label>
              <input
                type='text'
                style={{
                  border: `${errors.item_id ? '1px solid tomato' : ''}`,
                }}
                {...register('item_id', { required: true })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>store_SKU:</label>
              <input
                type='text'
                style={{
                  border: `${errors.store_sku ? '1px solid tomato' : ''}`,
                }}
                {...register('store_sku', { required: true })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Sec_Store_SKU:</label>
              <input
                type='text'
                style={{
                  border: `${errors.sec_store_sku ? '1px solid tomato' : ''}`,
                }}
                {...register('sec_store_sku', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Model_Number:</label>
              <input
                type='text'
                style={{
                  border: `${errors.model_number ? '1px solid tomato' : ''}`,
                }}
                {...register('model_number', { required: true })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Rating:</label>
              <input
                type='text'
                style={{ border: `${errors.rating ? '1px solid tomato' : ''}` }}
                {...register('rating', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Price:</label>
              <input
                type='text'
                style={{ border: `${errors.price ? '1px solid tomato' : ''}` }}
                {...register('price', { required: true })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Was Price:</label>
              <input
                type='text'
                style={{
                  border: `${errors.was_price ? '1px solid tomato' : ''}`,
                }}
                {...register('was_price', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Date:</label>
              <input
                type='text'
                style={{ border: `${errors.date ? '1px solid tomato' : ''}` }}
                {...register('date', { required: false })}
              />
            </div>
            <div className='control'>
              <label htmlFor=''>Count:</label>
              <input
                type='number'
                style={{ border: `${errors.count ? '1px solid tomato' : ''}` }}
                {...register('count', { required: true })}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className='control'>
          <label htmlFor=''>Description</label>
          <textarea
            name=''
            id=''
            cols='30'
            rows='4'
            style={{
              border: `${errors.description ? '1px solid tomato' : ''}`,
            }}
            {...register('description', { required: true })}
          ></textarea>
        </div>
        <div className='control'>
          <label htmlFor=''>Feature_bullets</label>
          <textarea
            name=''
            id=''
            cols='30'
            rows='3'
            style={{
              border: `${errors.feature_bullets ? '1px solid tomato' : ''}`,
            }}
            {...register('feature_bullets', { required: true })}
          ></textarea>
        </div>
        <div className='control'>
          <label htmlFor=''>Descriptive_attributes</label>
          <textarea
            name=''
            id=''
            cols='30'
            rows='3'
            style={{
              border: `${
                errors.descriptive_attributes ? '1px solid tomato' : ''
              }`,
            }}
            {...register('descriptive_attributes', { required: true })}
          ></textarea>
        </div>
        <div className='control'>
          <label htmlFor=''>specifications</label>
          <textarea
            name=''
            id=''
            cols='30'
            rows='3'
            style={{
              border: `${errors.specifications ? '1px solid tomato' : ''}`,
            }}
            {...register('specifications', { required: true })}
          ></textarea>
        </div>
        <div className='control'>
          <label htmlFor=''>Categrories</label>
          <input
            type='text'
            style={{ border: `${errors.categories ? '1px solid tomato' : ''}` }}
            {...register('categories', { required: true })}
          />
        </div>
        <div className='buttons'>
          <Link to='/' className='btn cancel'>
            NEW SEARCH
          </Link>
          <button id='updateSave' onClick={onSubmit} className='btn'>
            {inv ? 'UPDATE' : 'SAVE TO INVENTORY'}
          </button>
          <ReactToPrint
            trigger={() => (
              <button className='btn print' type='button'>
                PRINT
              </button>
            )}
            content={() => printRef.current}
            // pageStyle="@page { size: 4in 2.3in landscape; margin: 0; } body { margin: 0; }"
          />
        </div>
      </form>
      <div style={{ display: 'none' }}>
        <PrintComponent
          ref={printRef}
          formData={formData}
          calculateOurPrice={calculateOurPrice}
        />
      </div>
    </div>
  );
};

export default Results;
